import { FC } from 'react';
import { HStack, VStack } from '@chakra-ui/react';

import IconButton from 'components/_core/IconButton';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import Tooltip from 'components/_core/Tooltip';

import locales from './locales';

interface ReorderingHeaderProps {
  handleTaskOrderChange: (index: number, direction: 'up' | 'down') => void;
  index: number;
  hasTagIcon: boolean;
  moveDownIsDisabled: boolean;
  moveUpIsDisabled: boolean;
}

const ReorderingHeader: FC<ReorderingHeaderProps> = ({
  handleTaskOrderChange,
  hasTagIcon,
  index,
  moveDownIsDisabled,
  moveUpIsDisabled,
}) => (
  <SunshineCard paddingY="space-8!important">
    <HStack justifyContent="space-between">
      <HStack gap="space-16">
        <Text color="primary" fontWeight="weight-500">
          {locales.formatString(locales.label, {
            index: index + 1,
          })}
        </Text>

        {hasTagIcon ? (
          <SunshineIcon color="light" name="tag" size="icon-16" />
        ) : null}
      </HStack>

      <VStack gap={0}>
        <Tooltip
          closeOnClick
          description={locales.moveUp}
          isDisabled={moveUpIsDisabled}
          openDelay={500}
        >
          <IconButton
            aria-label="up"
            color="primary"
            icon="chevron-up"
            iconSize="icon-24"
            isDisabled={moveUpIsDisabled}
            onClick={() => handleTaskOrderChange(index, 'up')}
            variant="inline-primary"
          />
        </Tooltip>

        <Tooltip
          closeOnClick
          description={locales.moveDown}
          isDisabled={moveDownIsDisabled}
          openDelay={500}
          placement="bottom"
        >
          <IconButton
            aria-label="down"
            color="primary"
            icon="chevron-down"
            iconSize="icon-24"
            isDisabled={moveDownIsDisabled}
            onClick={() => handleTaskOrderChange(index, 'down')}
            variant="inline-primary"
          />
        </Tooltip>
      </VStack>
    </HStack>
  </SunshineCard>
);

export default ReorderingHeader;
